import { useRef, useEffect } from 'react'
import type { DataLayerAction } from '../TagContext.d'
import { useObjectCompare } from '../hooks/useObjectCompare'
import { getUUIDCookie, checkIsVisitorNew } from './UserCookies'
import { useRouter } from 'next/router'
import { useUser } from '@corratech/pylot-auth-manager'
export const hasToken = (): boolean => {
    if (typeof window !== 'object') {
        return false
    }
    return !!window.localStorage.getItem('pylot_token')
}
export const TrackUserData = ({
    dataLayerAction
}: {
    dataLayerAction: DataLayerAction
}): null => {
    const { isFallback } = useRouter()
    // Keep a track of the login state
    const trackedLoggedInState = useRef(hasToken())

    const { isSignedIn, loading, customer, error } = useUser()

    const userStateHasChanges = useObjectCompare()

    // After the initial page load, we can start tracking user state after we reach one of these states:
    // 1. user does not have a token and user data is undefined; 2. user has token and user data
    const canTrackUserState = () => {
        if (loading || isFallback) {
            return false
        }
        if (error) {
            return true
        }
        return (hasToken() && customer) || (!hasToken() && !customer)
    }

    useEffect(() => {
        if (!canTrackUserState()) {
            return
        }
        let actionType
        if (trackedLoggedInState.current !== isSignedIn) {
            actionType = isSignedIn ? 'USER_LOGIN' : 'USER_LOGOUT'
            trackedLoggedInState.current = isSignedIn
        } else if (userStateHasChanges(customer, true) || error) {
            actionType = 'USER_STATE'
        }
        if (actionType) {
            dataLayerAction({
                type: actionType,
                data: {
                    isSignedIn,
                    UID: getUUIDCookie(),
                    isNew: Number(checkIsVisitorNew()),
                    email: customer ? String(customer.email) : '',
                    userData: customer ?? {}
                }
            })
        }
    }, [isSignedIn, customer, loading])

    return null
}
